import { render, staticRenderFns } from "./LoginIAMSmartPendingView.vue?vue&type=template&id=dd6d4a4a&"
import script from "./LoginIAMSmartPendingView.vue?vue&type=script&lang=js&"
export * from "./LoginIAMSmartPendingView.vue?vue&type=script&lang=js&"
import style0 from "./LoginIAMSmartPendingView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports